"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _dicts = require("@package/dicts");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ModifyForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      disabled = _ref.disabled;

  try {
    var formValues = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('create-refund'));
    return /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Container, null, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line__value']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      "data-locator": "refund.amount",
      label: "\u0421\u0443\u043C\u043C\u0430",
      name: "amount",
      disabled: disabled
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line__aside'],
      "data-locator": "refund.currency"
    }, _dicts.CURRENCY_SYMBOLS[formValues['currency']])))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.TextareaField, {
      "data-locator": "refund.reason",
      label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
      name: "reason",
      disabled: disabled
    })))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ModifyForm;
exports["default"] = _default;